
import React, { useState, useEffect } from "react";
import { MapContainer, TileLayer, Polygon, Popup } from 'react-leaflet';
import ClipLoader from 'react-spinners/ClipLoader';


function Zones({TransportMeansSelection}) {
    const [loading, setLoading] = useState(false); // Track loading state
    const [zones, setZones] = useState([]);

    useEffect(() => {
        setLoading(true); // Start loading
        var url = '/api/roadtransport/zones';

        fetch(url).then((res) =>
           res.json().then((res) => {
            var dataTable = []
           
            res.data.forEach((obj, i) => {
                obj.Coordinates.forEach((pos) => {
                  let temp = pos[0]
                  pos[0] = pos[1]
                  pos[1] = temp
                })

                dataTable.push(obj) 
           });
            console.log(dataTable)
            setZones(dataTable)
            setLoading(false); // Stop loading once data is fetched
          })
        )
        .catch((error) => {
          console.log("Refetching data for Markers!")
        });
      }, []);

    
    
      const center = [39.0742, 21.8243];
      const zoom = 7;
    
    
    if(!loading){
      return (
        <div className = "container" style = {{marginBottom: "5%"}}>
            <p style = {{color: "orange"}}>*Για περισσότερες πληροφορίες πατήστε πάνω στην ζώνη.</p>
            <MapContainer
            center={center}
            zoom={zoom}
            //SOS It MUST HAVE STATIC HEIGHT IN ORDER TO SHOW
            style={{ height: "600px", width: "100%" }}
            >
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                />
             {zones.map((zone, index) => (
                <Polygon key={index} pathOptions={{ color: "purple" }} positions={zone.Coordinates}>
                   <Popup>
                    <div>
                      <p>ID: {zone["ID"]}</p>
                      <p>Ονομασία: {zone.ZoneName}</p>
                    </div>
                  </Popup>
                </Polygon>
            ))}
            
            </MapContainer>
        </div>
      );
    }else{
      return(
        <div className="container" style = {{marginLeft: "40%"}}>
          <ClipLoader size={100} color={'#123abc'} loading={true}/>
        </div>
      )
    }
    
  
}

export default Zones;
